import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Slider from "react-slick";

function SmartsoftFlyontopPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    const { showOnlyOnFomo } = theme.config;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    const domain = (brandId == 31 || brandId == 32) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'IW247';

    return (
        <>
            <InformationWrapper>
                    <TitleText>
                        <div className=''>
                            <p className='purple-strong'>Get ready for high-speed thrills and sky-high wins! YOLO247 and Smartsoft Instant Games bring</p>
                            <p className='purple-strong'>you the <b>“Fly to the Top”</b> leaderboard challenge this July.</p>
                        </div>
                        <div>
                            <p>Play your favorite instant games like JetX, BaloonX, CricketX etc to climb the leaderboard and win!</p>
                        </div>
                    </TitleText>
                <ImageWrapper>
                    <Container>
                          <MainTitle>How to Participate</MainTitle>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTmainSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                    </Container>
                </ImageWrapper> 

                <PriceBreakDown>
                    <MainTitle>weekly prize amount</MainTitle>
                    <SliderWrapper>
                        <Slider {...settings}>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize01}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize02}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize03}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize04}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize05}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize06}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize07}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize08}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize09}`}/></div>
                                <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrize10}`}/></div>
                        </Slider>
                    </SliderWrapper>
                </PriceBreakDown>

                <MonthlyPrizeWrap>
                    <MainTitle>Monthly prize amount</MainTitle>
                    <p>Random selector from top players in the weekly leaderboard</p>
                    <MonthlyPrizeSec>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrizeMonthly01}`}/>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrizeMonthly02}`}/>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.FOTTPromoPrizeMonthly03}`}/>
                    </MonthlyPrizeSec>
                </MonthlyPrizeWrap>
                
                <TermsConditionsSec>
                  <MainTitle>Terms & Conditions</MainTitle>
                    <ol>
                        <li>Only real money bets on Smartsoft Instant Games are eligible.</li>
                        <li>Leaderboards are based on total turnover (not winnings).</li>
                        <li>Weekly prizes are paid as bonuses.</li>
                        <li>Winners must complete KYC and provide a valid USDT wallet address if required.</li>
                        <li>Leaderboards reset every day at midnight (IST).</li>
                        <li>All rewards are processed after internal verification.</li>
                        <li>Any suspicious or fraudulent activity may lead to disqualification.</li>
                        <li>YOLO247 reserves the right to change or withdraw the promotion at any time.</li>
                    </ol>
                </TermsConditionsSec>

                <DividerLine></DividerLine>
                <p className='footerText'>Start playing Smartsoft's thrilling instant games on YOLO247 and climb to win. The sky's the limit!</p>
                

                
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(SmartsoftFlyontopPromo));

const UnderLine = styled.div`
    height: 2px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);

    &.paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    &.marginTop {
        margin: 0 auto;
        margin-top: 1rem;
    }
`;


const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 3px solid #ffffff;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li button:before {
            color: #fff;
            font-size: 15px;
            opacity: unset;
        }

        li.slick-active button:before {
            opacity: unset;
            color: #FF00EE;
        }
    }
`;

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.FOTTPromoInnerBG")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .boldText {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    .shadowLine {
        background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
        -webkit-backdrop-filter: blur(6.849999904632568px);
        backdrop-filter: blur(6.849999904632568px);
        width: 100%;
        padding-top: 2rem;
    }

    .purple-strong {
        color: #FFDD00;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 25px; /* 166.667% */
        text-transform: capitalize;
        margin: 3px 0px;

        & b {
            color: #fff;
        }
    }

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .footerText {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 120% */
        text-transform: capitalize;
        margin: 10px 0px 0px 0px;
    }
`;

const PriceBreakDown = styled.div`
    width: 80%;
    padding: 2rem 0;
    position: relative;
    margin: auto;
`;



const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 15px;
    /* margin-bottom: 2rem; */


    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
    }

    .mt-10 {
        margin-top: 15px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;


    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;


const Container = styled.div`
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 70%;
      height: auto;
    }

`;

const MainTitle = styled.h4`
        color: #FFEE00;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 35px; /* 175% */
        text-transform: capitalize;
        margin: 3px 0px 15px 0px;
`


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
    
`

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`

const KeyDetailsSecBox = styled.div`
    width: 23%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    border: 0.5px solid ${theme('palette.weeklyLeaderboardBorder')};
    background: ${theme('palette.weeklyLeaderboardBg')};
    backdrop-filter: blur(12.5px);

    & p {
        color: #FFF;
        text-align: center;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`

const MonthlyPrizeSec = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    & img {
        width: 20%;
        height: auto;
    }
`

const MonthlyPrizeWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    margin-top: 2em;

    & p {
        color: #fff;
        text-transform: capitalize;
        margin: -10px 0px 15px 0px;
    }
`

const TermsConditionsSec = styled.div`
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 5px;
     margin-top: 2em;

     & ol {
        margin-top: 5px;

        & li {
            color: #FFF;
            text-align: justify;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            text-transform: capitalize;
            margin: 3px 0px;
        }
     }
`

const DividerLine = styled.div`
    height: 1px;
    width: 40%;
    margin: 20px auto;
    background-color: #fff;
`